import isFetchError from './isFetchError';

/**
 * True when the request never received an HTTP response, i.e. ofetch bailed out before
 * `context.response` was ever set, leaving `status`, `statusCode` and `data` undefined.
 *
 * Causes are indistinguishable from each other by design (the browser reports the same
 * `TypeError` for all of them, to avoid leaking cross-origin information): no connectivity,
 * DNS failure, TLS failure, CORS block, captive portal, adblock, CSP. Callers must therefore
 * say the server is unreachable, never that the user is offline.
 *
 * Aborted requests are excluded: they are cancellations, not failures.
 */
export default (error: unknown): boolean => isFetchError(error) && !error.response && (error.cause as Error | undefined)?.name !== 'AbortError';
